import { Schema, z } from 'zod';

/**
 * Activation status of a definition.
 */
export type DefinitionStatusType = 'active' | 'inactive';

/**
 * Activation status of this zone definition.
 */

export enum DefinitionStatus {
  Active = 'active',
  Inactive = 'inactive'
}

export const DefinitionStatusSchema: Schema<DefinitionStatusType> =
  z.nativeEnum(DefinitionStatus);
